import { User } from '@antegma/accallio-cloud-management-api'
import { AnyAction } from 'redux'
import actions from './actions'

export type TUserDetailsState = {
  user: User
  loading: boolean
}

const initialState = {
  user: {},
  loading: false,
}

/**
 * @param state
 * @param action
 */
export default function usersReducer(state: TUserDetailsState = initialState, action: AnyAction): TUserDetailsState {
  switch (action.type) {
    case actions.SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.GET_STATE:
      return state
    default:
      return state
  }
}
